export default __webpack_public_path__ + "static/media/206.8286bf70.jpeg";